module.exports = __webpack_public_path__ + "static/media/noAvailable.93caeccf.png";